var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": _vm.currentEventPageTitle
    }
  })], 1)], 1), _c('div', {
    staticClass: "events-container container p-0"
  }, [_c('SearchControlWidget', {
    attrs: {
      "inputTextPlaceholder": 'Enter event name here',
      "searchControlHeight": '100px',
      "searchQueryInputHandler": _vm.receiveSearchQuery,
      "searchControlMarginTop": 'mt-5'
    }
  }), _c('section', {
    staticClass: "section p-0 mt-3",
    attrs: {
      "id": "toggling-tabs"
    }
  }, [_c('div', {
    staticClass: "container-fluid p-0"
  }, [_c('div', {
    staticClass: "row toggle-tab"
  }, [_c('div', {
    staticClass: "col-4 px-0 d-flex flex-row align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "toggle-tab-item",
    class: _vm.upcompingEventsTabClass,
    on: {
      "click": _vm.toggleUpcomingEvents
    }
  }, [_vm._v("Upcoming Events")])]), _c('div', {
    staticClass: "col-4 px-0 d-flex flex-row align-items-center justify-content-center"
  }, [_c('div', {
    staticClass: "toggle-tab-item",
    class: _vm.pastEventsTabClass,
    on: {
      "click": _vm.togglePastEvents
    }
  }, [_vm._v("Past Events")])]), _c('div', {
    staticClass: "col-4 px-0 d-flex flex-row align-items-center justify-content-start"
  }, [_c('div', {
    staticClass: "toggle-tab-item",
    class: _vm.pastEventsVideosTabClass,
    on: {
      "click": _vm.togglePastEventVideos
    }
  }, [_vm._v("Event Videos")])])])])]), _c('section', {
    staticClass: "section p-0 mt-2"
  }, [_vm.currentPageEventItems.length > 0 ? _c('div', {
    staticClass: "container-fluid p-0 d-flex flex-column align-items-center pt-3 mb-4 px-1 px-md-0 px-lg-0 px-xl-0"
  }, [_vm.currentSelection === 'all' || _vm.currentSelection === 'upcoming' || _vm.currentSelection === 'past' ? _c('div', {
    staticClass: "w-100 h-auto"
  }, _vm._l(_vm.currentPageEventItems, function (eventItem) {
    var _vm$nextEvent, _eventItem$cyberBanne, _eventItem$status, _eventItem$title, _eventItem$startAt, _eventItem$headLine;
    return _c('div', {
      key: eventItem.id,
      staticClass: "row m-0 event-row-item2",
      attrs: {
        "id": ((_vm$nextEvent = _vm.nextEvent) === null || _vm$nextEvent === void 0 ? void 0 : _vm$nextEvent.id) === eventItem.id ? _vm.nextEvent.id : eventItem.id
      }
    }, [_c('div', {
      staticClass: "col-12 p-0"
    }, [_c('div', {
      staticClass: "row m-0 h-100"
    }, [_c('div', {
      staticClass: "col-lg-5 col-md-5 col-sm-12 col-xs-12 p-0"
    }, [_c('div', {
      staticClass: "d-flex flex-row justify-content-center align-items-center event-item-size"
    }, [_c('div', {
      staticClass: "event-image-container2 d-flex flex-column justify-content-center"
    }, [_c('img', {
      staticClass: "event-image-info",
      attrs: {
        "src": ((_eventItem$cyberBanne = eventItem.cyberBannerLink) !== null && _eventItem$cyberBanne !== void 0 ? _eventItem$cyberBanne : eventItem.imageURL) || require('@assetsImages/services/webinar.jpeg'),
        "alt": ""
      }
    })])])]), _c('div', {
      staticClass: "col-lg-7 col-md-7 col-sm-12 col-xs-12 p-0 pb-md-0 pb-lg-0 pb-xl-0",
      class: (eventItem === null || eventItem === void 0 ? void 0 : (_eventItem$status = eventItem.status) === null || _eventItem$status === void 0 ? void 0 : _eventItem$status.length) > 0 && 'pb-3'
    }, [_c('div', {
      staticClass: "w-100 h-100"
    }, [_c('div', {
      staticClass: "h-100 event-info-container2 px-3 py-3 px-md-2 px-lg-2 px-xl-2 py-md-4 py-lg-4 py-xl-4 d-flex flex-column"
    }, [_c('div', {
      staticClass: "row m-0 pb-1",
      staticStyle: {
        "width": "100%",
        "min-height": "10%"
      }
    }, [_c('div', {
      staticClass: "col-12 p-0 text-left d-flex align-items-end event-info event-info-header"
    }, [_vm._v(" " + _vm._s((_eventItem$title = eventItem.title) !== null && _eventItem$title !== void 0 ? _eventItem$title : eventItem.eventTitle) + " ")])]), _c('div', {
      staticClass: "row m-0",
      staticStyle: {
        "width": "100%",
        "height": "20%"
      }
    }, [_c('div', {
      staticClass: "col-12 p-0 text-left pt-1 event-info event-info-header"
    }, [_vm._v(" " + _vm._s(_vm.formatEventDate((_eventItem$startAt = eventItem.startAt) !== null && _eventItem$startAt !== void 0 ? _eventItem$startAt : eventItem.date)) + " ")])]), _c('div', {
      staticClass: "row m-0 d-flex flex-column justify-content-center",
      staticStyle: {
        "width": "100%",
        "height": "40%"
      }
    }, [_c('div', {
      staticClass: "h-100 col-12 p-0 d-flex flex-column justify-content-start"
    }, [_c('div', {
      staticClass: "event-info event-info-description text-left",
      domProps: {
        "innerHTML": _vm._s((_eventItem$headLine = eventItem.headLine) !== null && _eventItem$headLine !== void 0 ? _eventItem$headLine : eventItem.description)
      }
    })])]), _c('div', {
      staticClass: "row m-0",
      staticStyle: {
        "width": "100%",
        "height": "30%"
      }
    }, [_vm.isUpcomingEventsSelected ? _c('div', {
      staticClass: "col-12 p-0 d-flex flex-row justify-content-start align-items-end"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: eventItem.title ? 'cyber-circuits-detail' : 'event-detail',
          query: {
            id: eventItem.id,
            eventPage: String(_vm.currentEventPage),
            query: _vm.eventSearchQuery,
            eventType: _vm.currentSelection,
            isEventArchived: _vm.isPastEventsArchived
          }
        }
      }
    }, [_c('v-btn', {
      attrs: {
        "rounded": "",
        "large": "",
        "dark": "",
        "color": _vm.primaryButtonColor,
        "width": "180"
      }
    }, [_vm._v(" Learn More ")])], 1)], 1) : _c('div', {
      staticClass: "col-12 p-0 d-flex align-items-end justify-content-start justify-content-md-end justify-content-lg-end justify-content-xl-end"
    }, [_c('div', {
      staticClass: "w-auto h-auto",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('img', {
      attrs: {
        "src": require('@assetsImages/Share-08.svg'),
        "width": "20px",
        "height": "20px"
      },
      on: {
        "click": function () {
          return _vm.toggleEventCopyUrl(eventItem.id);
        }
      }
    }), _vm.globalEventItemId === eventItem.id ? _c('CopyUrlClipboard', {
      class: _vm.copyUrlClass,
      attrs: {
        "copyHandlerComplete": function () {
          return _vm.toggleEventCopyUrl(eventItem.id);
        },
        "urlSource": `${_vm.urlRootPath}/#/event-detail?id=${_vm.globalEventItemId}&eventType=${_vm.currentSelection}&eventPage=${_vm.currentEventPage}&query=${_vm.eventSearchQuery}&isEventArchived=${_vm.isPastEventsArchived}`
      }
    }) : _vm._e()], 1)])])])])])])])]);
  }), 0) : _vm.currentSelection === 'pastEventsWithVideos' ? _c('div', {
    staticClass: "w-100 h-auto"
  }, _vm._l(_vm.currentPageEventItems, function (eventItem) {
    var _eventItem$title2, _eventItem$startAt2, _eventItem$headLine2;
    return _c('div', {
      key: eventItem.id,
      staticClass: "row m-0 my-2 event-video-row"
    }, [_c('div', {
      staticClass: "col-12 p-0 p-2 d-flex justify-content-center"
    }, [_c('div', {
      staticClass: "h-100 d-flex flex-column justify-content-start",
      class: _vm.videoContainer
    }, [_c('div', {
      staticClass: "w-100 mb-2",
      staticStyle: {
        "height": "60%"
      }
    }, [_c('YoutubeVideoWidget', {
      ref: eventItem === null || eventItem === void 0 ? void 0 : eventItem.youtubeID,
      refInFor: true,
      attrs: {
        "youtubeID": eventItem === null || eventItem === void 0 ? void 0 : eventItem.youtubeID,
        "options": eventItem === null || eventItem === void 0 ? void 0 : eventItem.videoOptions,
        "status": eventItem === null || eventItem === void 0 ? void 0 : eventItem.status,
        "activeYoutubeID": _vm.activeYoutubeID,
        "updaterHandler": _vm.youtubeUpdateOptionsHandler,
        "pauseYoutubeIDVideo": _vm.pauseVideoHandler
      },
      on: {
        "changeYoutubeVideoPlay": _vm.changeYoutubeVideoPlayingHandler
      }
    })], 1), _c('div', {
      staticClass: "w-100 d-flex flex-column mb-2",
      staticStyle: {
        "height": "10%"
      }
    }, [_c('div', {
      staticClass: "w-100 text-left event-info event-info-header d-flex align-items-end flex-grow-1"
    }, [_vm._v(" " + _vm._s((_eventItem$title2 = eventItem.title) !== null && _eventItem$title2 !== void 0 ? _eventItem$title2 : eventItem.eventTitle) + " ")]), _c('div', {
      staticClass: "w-100 text-left event-info event-info-header d-flex align-items-center flex-grow-1"
    }, [_vm._v(" " + _vm._s(_vm.formatEventDate((_eventItem$startAt2 = eventItem.startAt) !== null && _eventItem$startAt2 !== void 0 ? _eventItem$startAt2 : eventItem.date)) + " ")])]), _c('div', {
      staticClass: "w-100",
      staticStyle: {
        "height": "17%"
      }
    }, [_c('div', {
      staticClass: "h-100 col-12 p-0 d-flex flex-column justify-content-start"
    }, [_c('div', {
      staticClass: "event-info event-info-description text-left",
      domProps: {
        "innerHTML": _vm._s((_eventItem$headLine2 = eventItem.headLine) !== null && _eventItem$headLine2 !== void 0 ? _eventItem$headLine2 : eventItem.description)
      }
    })])]), _c('div', {
      staticClass: "w-100 d-flex flex-column mb-3",
      staticStyle: {
        "height": "13%"
      }
    }, [_c('div', {
      staticClass: "w-100 flex-grow-1 d-flex justify-content-start align-items-center event-video-status"
    }, [_vm._v(" " + _vm._s(eventItem.status) + " ")]), _c('div', {
      staticClass: "w-100 d-flex justify-content-start align-items-end"
    }, [_c('div', {
      staticClass: "w-auto d-flex justify-content-center event-videos-ctrl-row"
    }, [_c('img', {
      staticStyle: {
        "position": "relative",
        "bottom": "0"
      },
      attrs: {
        "src": require('@assetsImages/youtube-brands-1.svg'),
        "width": "30px",
        "height": "30px"
      },
      on: {
        "click": function () {
          return _vm.openYoutubeVideo(eventItem === null || eventItem === void 0 ? void 0 : eventItem.youtubeID);
        }
      }
    }), _c('div', {
      staticClass: "w-auto h-auto d-flex align-items-center",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('img', {
      attrs: {
        "src": require('@assetsImages/Share-08.svg'),
        "width": "20px",
        "height": "20px"
      },
      on: {
        "click": function () {
          return _vm.toggleEventCopyUrl(eventItem.id);
        }
      }
    }), _vm.globalEventItemId === eventItem.id ? _c('CopyUrlClipboard', {
      staticClass: "share-button-position",
      attrs: {
        "copyHandlerComplete": function () {
          return _vm.toggleEventCopyUrl(eventItem.id);
        },
        "urlSource": `${_vm.urlRootPath}/#/event-detail?id=${_vm.globalEventItemId}&eventType=${_vm.currentSelection}&eventPage=${_vm.currentEventPage}&query=${_vm.eventSearchQuery}&isEventArchived=${_vm.isPastEventsArchived}`
      }
    }) : _vm._e()], 1)])])])])])]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "w-100 row m-0 my-4 d-flex flex-column event-last-row"
  }, [_vm.totalEvents > _vm.eventsPerPage ? _c('div', {
    staticClass: "col-12 p-0"
  }, [_c('b-pagination', {
    staticClass: "ml-0",
    attrs: {
      "id": "event-list-items",
      "total-rows": _vm.totalEvents,
      "per-page": _vm.eventsPerPage,
      "align": "center"
    },
    on: {
      "page-click": _vm.pageClicked
    },
    model: {
      value: _vm.currentEventPage,
      callback: function ($$v) {
        _vm.currentEventPage = $$v;
      },
      expression: "currentEventPage"
    }
  })], 1) : _vm._e(), _vm.isPastEventsSelected ? _c('div', {
    staticClass: "col-12 p-0 d-flex justify-content-center"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": _vm.primaryButtonColor,
      "width": "240"
    },
    on: {
      "click": function ($event) {
        _vm.isPastEventsArchived = !_vm.isPastEventsArchived;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isPastEventsArchived ? 'Back to Recent Events' : 'View Archives') + " ")])], 1) : _vm._e()])]) : _c('div', {
    staticClass: "container d-flex justify-content-center align-items-center empty-event-message text-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.emptyEventsMessage))])])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }